<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>Copyright © 2019 by University of Massachusetts Press</p>
<p class="crt">All rights reserved</p>
<p class="crt">Printed in the United States of America</p>
<p class="cipf">ISBN 978-1-61376-689-7 (ebook)</p>
<p class="crtf">Cover design by Thomas Eykemans</p>
<p class="crt">Cover photo by Idaho Sagebrush, Fallujah, 2004, www.flickr.com/photos/idahosagebrush/9197397204/. Licensed under https://creativecommons.org/licenses/by/2.0/.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Caputi, Ross, author. | Hill, Richard, 1949–author. | Mulhearn,Donna, author.</p>
<p class="cip">Title: The sacking of Fallujah : a people’s history / Ross Caputi, Richard Hill, and Donna Mulhearn.</p>
<p class="cip">Description: Amherst : University of Massachusetts Press, 2019. | Series: Culture and politics in the Cold War and beyond | Includes bibliographical references and index. |</p>
<p class="cip">Identifiers: LCCN 2018051545 (print) | LCCN 2018055901 (ebook) | ISBN</p>
<p class="cip">9781613766880 (ebook) | ISBN 9781613766897 (ebook) | ISBN 9781625344373 |</p>
<p class="cip">ISBN 9781625344373(hardcover) | ISBN 9781625344380(pbk.)</p>
<p class="cip">Subjects: LCSH: Fall?ujah (Iraq)—History—21st century. | Fallujah, Battle of, Fall?ujah, Iraq, 2004. | Iraq War, 2003–2011—Campaigns—Iraq—Fall?ujah. | IS (Organization)</p>
<p class="cip">Classification: LCC DS79.764.F35 (ebook) | LCC DS79.764.F35 C37 2019 (print) | DDC 956.7044/342—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2018051545" target="_blank">https://lccn.loc.gov/2018051545</a></p>
<p class="cipf">British Library Cataloguing-in-Publication Data</p>
<p class="cip">A catalog record for this book is available from the British Library.</p>
<p class="crtf"><i>All photos in the gallery by Donna Mulhearn.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-CAPUTI-0005.vue?2c647f09